function About() {
  return (
    <div>
      <h1 className='text-6xl mb-4'>Github Finder</h1>
      <p>
        GitHub Finder is a powerful tool designed to simplify your experience in
        discovering and connecting with developers, projects, and repositories
        on GitHub. Whether you're a seasoned developer seeking collaboration
        opportunities or a curious enthusiast exploring the vast world of
        open-source software, GitHub Finder has got you covered.
        <h1>Our Mission:</h1>
        At GitHub Finder, our mission is to empower individuals and teams in
        harnessing the full potential of GitHub's extensive ecosystem. We strive
        to bridge the gap between developers, facilitate seamless collaboration,
        and foster innovation by providing intuitive tools and features tailored
        to enhance your GitHub experience.
      </p>
    </div>
  );
}

export default About;
